import { LoadingButton } from "@mui/lab";
import { capitalize, startCase, toLower } from "lodash";
import {
  Box,
  IconButton,
  InputAdornment,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import Iconify from "src/components/Iconify";
import { useState } from "react";
import { BodyRow } from "src/components/custom-table";
import DataHandlerList from "src/components/data-handler/list";
import EmptyTable from "src/components/emptyTable";
import Map from "src/components/map";

import Translate from "src/components/translate";
import { from } from "stylis";
import useIncentive from "./hooks/useIncentive";

const Incentive = () => {
  const { state, handleUpdate, onSubmit } = useIncentive();

  const { data, ...dataProps } = state;

  console.log(data);
  return (
    <>
      <DataHandlerList dataProps={{ ...dataProps }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Translate>{"global.type"}</Translate>
              </TableCell>
              <TableCell>
                <Translate>{"global.value"}</Translate>
              </TableCell>
              <TableCell>
                <Translate>{"global.incentive_points"}</Translate>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* <Map
              list={data}
              render={(item) => (
                <Row
                  key={item.id}
                  {...item}
                  onSubmit={onSubmit}
                  handleUpdate={handleUpdate}
                  {...item}
                />
              )}
            /> */}
            <Map
              list={data}
              render={(item) => (
                <Row
                  key={item.id}
                  {...item}
                  onSubmit={onSubmit}
                  handleUpdate={handleUpdate}
                />
              )}
            />
          </TableBody>
        </Table>

        <Box textAlign="right">
          <Stack alignItems="flex-end" sx={{ mt: 3 }}>
            <LoadingButton onClick={onSubmit} type="submit" variant="contained">
              <Translate>{"settings.network.update"}</Translate>
            </LoadingButton>
          </Stack>
        </Box>
      </DataHandlerList>
    </>
  );
};

const Row = ({ id, type, unit_value, ip_value, handleUpdate }) => {
  return (
    <TableRow>
      <TableCell sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        <TextField
          type="text"
          size="small"
          value={startCase(toLower(type))}
          disabled
          sx={{ width: "230px" }}
        />
        <Typography>
          {type === "direct_referral"
            ? `No. of Direct Referrals :`
            : type === "personal_volume"
            ? `Total Personal Volume :`
            : type === "group_volume"
            ? `Total Team Volume :`
            : ""}
        </Typography>
      </TableCell>

      <TableCell>
        <LoadingTextField
          value={unit_value}
          name="unit_value"
          handleUpdate={handleUpdate(id)}
        />
      </TableCell>

      <TableCell>
        <LoadingTextField
          value={ip_value}
          name="ip_value"
          handleUpdate={handleUpdate(id)}
        />
      </TableCell>
    </TableRow>
  );
};

const LoadingTextField = ({ value, name, handleUpdate }) => {
  const [loading, setLoading] = useState(false);
  const onChange = (e) => {
    setLoading(true);
    handleUpdate(e);
  };

  return (
    <TextField
      onWheel={(e) => e.target.blur()}
      type="number"
      onChange={onChange}
      size="small"
      value={value}
      name={name}
    />
  );
};

export default Incentive;
